// Emoji, tracking pixels, and signature icons stay below this; content images don't.
const MIN_EXPANDABLE_SIZE = 40

export function isExpandableImage(img: HTMLImageElement): boolean {
	if (img.closest("a[href]")) return false
	if (!img.getAttribute("src")) return false
	const width = img.naturalWidth || img.width
	const height = img.naturalHeight || img.height
	return width >= MIN_EXPANDABLE_SIZE && height >= MIN_EXPANDABLE_SIZE
}

export function collectExpandableImages(root: ParentNode): HTMLImageElement[] {
	return Array.from(root.querySelectorAll("img")).filter(isExpandableImage)
}

export function markExpandableImages(root: ParentNode): void {
	for (const img of root.querySelectorAll("img")) {
		img.style.cursor = isExpandableImage(img) ? "zoom-in" : ""
	}
}
